var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSoundOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-88 -498) translate(40 498) translate(48)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M10.906 4.65c.441-.356 1.094-.039 1.094.533v13.634c0 .572-.653.89-1.094.532l-4.623-3.746h-3.61c-.372 0-.673-.305-.673-.681V9.078c0-.376.301-.681.673-.681h3.61zm7.755 2.527c3.119 2.932 3.119 7.714 0 10.646-.267.252-.682.233-.927-.043-.244-.275-.226-.702.042-.954 2.549-2.397 2.549-6.255 0-8.652-.268-.252-.286-.679-.042-.954.245-.276.66-.295.927-.043zM16.1 9.586c1.702 1.6 1.702 4.221 0 5.822-.268.251-.683.232-.927-.044-.245-.275-.226-.702.042-.954 1.132-1.064 1.132-2.762 0-3.827-.268-.252-.287-.679-.042-.954.244-.276.66-.295.927-.043z",
    transform: "translate(-88 -498) translate(40 498) translate(48)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundOn);
export default __webpack_public_path__ + "static/media/iconSoundOn.2a2e1571.svg";
export { ForwardRef as ReactComponent };